<template>
  <div class="sdk_list_container">
    <div class="sdk_list_box">
      <div class="h2">
        <span>第三方SDK目录</span>
      </div>
      <div class="content">
        <p>第三方软件开发包（SDK）个人信息收集情况:</p>
        <p class="indent">为了使您能够在使用我们的服务时收到信息推送、在第三方平台分享信息、利用第三方平台账号进行登录及保障您的账号安全，我们集成了由第三方公司开发、提供的软件开发包（SDK），这些软件开发包（SDK）在实现功能时需要采集部分信息才可实现，具体如下：</p>
        <p class="indent">
          <span>（1）极光推送SDK。需要申请推送权限，收集您的设备信息，提供消息推送功能。</span>
        </p>
        <p class="indent">
          <span>（2）百度地图SDK。需要申请位置、语音权限，收集您的地理位置、音频信息，提供地图功能。</span>
        </p>
        <p class="indent">
          <span>（3）微信SDK。无需申请任何权限，收集您的用户ID，提供微信分享功能。</span>
        </p>
        <p class="indent">
          <span>（4）QQSDK。无需申请任何权限，未收集任何个人信息，提供QQ分享功能。</span>
        </p>
        <p class="indent">
          <span>（5）七牛云SDK。无需申请任何权限，未收集任何个人信息，提供图片、视频上传功能。</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "SDKList",
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["nodeCode", "appFullName"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: location.href
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, "第三方SDK目录 - 法治号客户端", _this.appFullName, location.href);
      }).catch((err) => {

      })
    },
  },
  created() {
    document.title = "第三方SDK目录";
    this.wechatShare(); // 微信二次分享
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.sdk_list_container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #000;
  display: flex;
  flex-direction: column;
  .sdk_list_box {
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
    * {
      word-break: break-all;
      white-space: normal;
      line-height: 1.5em;
      font-family: "Microsoft Yahei";
    }
    .h2 {
      padding: 18px 0;
      line-height: 27px;
      text-align: center;
      color: #000;
      font-size: 18px;
      font-weight: bolder;
    }
    .content {
      p {
        line-height: 27px;
        margin: 10px 0;
        color: #000;
        font-family: "Microsoft Yahei";
        font-size: 16px;
        text-align: justify;
        &.indent {
          text-indent: 2em;
        }
      }
    }
  }
}
</style>